<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="GOV_SCHEDULE_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="govScheduleTypeCd"
            label="대관업무 구분"
            v-model="searchParam.govScheduleTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            type="year"
            label="최근 실시기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="대관업무 목록"
      tableId="table"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLREG" icon="add" @btnClicked="linkClick" v-if="editable" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'click'">
          <q-chip
            color="blue"
            outline square
            :clickable="true"
            text-color="white"
            @click="linkClick2(props.row)">
            {{'이력'}}
          </q-chip>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'gov-schedule-manage',
  data() {
    return {
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'govScheduleTypeName',
            field: 'govScheduleTypeName',
            label: '대관업무구분',
            align: 'center',
            style: 'width: 250px',
            sortable: true,
          },
          {
            name: 'govScheduleName',
            field: 'govScheduleName',
            label: '대관업무명',
            type: 'link',
            align: 'left',
            sortable: true,
          },
          {
            name: 'inspTarget',
            field: 'inspTarget',
            label: '관할기관',
            align: 'center',
            style: 'width: 300px',
            sortable: true,
          },
          {
            name: 'recentlyExecDt',
            field: 'recentlyExecDt',
            label: '최근 실시일',
            align: 'center',
            style: 'width: 140px',
            sortable: true,
          },
          {
            name: 'click',
            field: 'click',
            type: 'custom',
            label: '이력보기',
            align: 'center',
            style: 'width: 100px',
            sortable: true,
          },
          // {
          //   name: 'nextExecDt',
          //   field: 'nextExecDt',
          //   label: '다음 예정일',
          //   align: 'center',
          //   style: 'width: 140px',
          //   sortable: true,
          // },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        govScheduleTypeCd: null,
        plantCd: null,
        period: [],
        useFlag: 'Y',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.gov.mst.list.url;
      this.getList();
    },
    getList() {
      if (this.searchParam.period.length == 2) {
        this.searchParam.startYmd = this.searchParam.period[0] + '-01-01';
        this.searchParam.endYmd = this.searchParam.period[1] + '-12-31';
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.detailPopup(row, '');
    },
    linkClick2(row) {
      this.detailPopup(row, 'govScheduleHistory');
    },
    detailPopup(result, _name) {
      this.popupOptions.target = () => import(`${"./govScheduleDetail.vue"}`);
      this.popupOptions.title = '대관업무 상세';
      this.popupOptions.param = {
        govScheduleMstId: result ? result.govScheduleMstId : '',
        tabname: _name ? _name : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
